import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaShoppingCart } from 'react-icons/fa';
import { useCart } from '../context/CartContext';

function Cart() {
  const { cartItems, updateQuantity, removeFromCart, getCartTotal } = useCart();
  const navigate = useNavigate();

  const handleQuantityChange = (productId, newQuantity) => {
    updateQuantity(productId, newQuantity);
  };

  const handleRemove = (productId) => {
    removeFromCart(productId);
  };

  const handleCheckout = () => {
    navigate('/checkout');
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-container">
        <Helmet>
          <title>Shopping Cart - Fitness Health Blog</title>
          <meta name="description" content="View your shopping cart" />
        </Helmet>

        <h1>Shopping Cart</h1>
        <div className="empty-cart">
          <FaShoppingCart size={100} color="#ddd" />
          <p>Your cart is empty</p>
          <Link to="/" className="btn-primary">Continue Shopping</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-container">
      <Helmet>
        <title>Shopping Cart - Fitness Health Blog</title>
        <meta name="description" content="Review your selected fitness and health products" />
      </Helmet>

      <h1>Shopping Cart</h1>

      <div className="cart-items">
        {cartItems.map(item => (
          <div key={item.id} className="cart-item">
            <img src={item.image} alt={item.name} className="cart-item-image" />
            
            <div className="cart-item-info">
              <h3>{item.name}</h3>
              <p>Price: £{item.price.toFixed(2)}</p>
              
              <div className="cart-item-controls">
                <button onClick={() => handleQuantityChange(item.id, item.quantity - 1)}>-</button>
                <span>{item.quantity}</span>
                <button onClick={() => handleQuantityChange(item.id, item.quantity + 1)}>+</button>
              </div>
              
              <button className="remove-button" onClick={() => handleRemove(item.id)}>
                Remove
              </button>
            </div>

            <div className="cart-item-total">
              <strong>£{(item.price * item.quantity).toFixed(2)}</strong>
            </div>
          </div>
        ))}
      </div>

      <div className="cart-summary">
        <h2>Order Summary</h2>
        
        <div className="summary-row">
          <span>Subtotal:</span>
          <span>£{getCartTotal().toFixed(2)}</span>
        </div>
        
        <div className="summary-row">
          <span>Shipping:</span>
          <span>Free</span>
        </div>
        
        <div className="summary-row total">
          <span>Total:</span>
          <span>£{getCartTotal().toFixed(2)}</span>
        </div>

        <button className="checkout-button" onClick={handleCheckout}>
          Proceed to Checkout
        </button>

        <Link to="/" style={{ display: 'block', textAlign: 'center', marginTop: '1rem', color: '#667eea' }}>
          Continue Shopping
        </Link>
      </div>
    </div>
  );
}

export default Cart;